import EthIcon from '@/app/assets/token/eth.svg?react';
import TetrationIcon from '@/app/assets/token/tetration.svg?react';
import WyldsIcon from '@/app/assets/token/wylds.png';

const MARKET_META_ITEMS = [
  { label: 'Chain', value: 'Ethereum', Icon: EthIcon },
  { label: 'Asset', value: 'wYLDS', iconSrc: WyldsIcon },
  { label: 'Curator', value: 'Tetration', Icon: TetrationIcon },
] as const;

const MarketDetailsMeta = () => {
  return (
    <div className='flex flex-wrap items-center gap-x-8 gap-y-4'>
      {MARKET_META_ITEMS.map((item) => (
        <div key={item.label} className='flex items-center gap-2.5'>
          {'Icon' in item ? (
            <item.Icon className='h-8 w-8 shrink-0' aria-hidden />
          ) : (
            <img src={item.iconSrc} alt='' className='h-8 w-8 shrink-0 rounded-full' aria-hidden />
          )}
          <div className='flex flex-col'>
            <span className='text-xs leading-4 text-gray-400'>{item.label}</span>
            <span className='text-base leading-6 font-normal text-gray-200'>{item.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MarketDetailsMeta;
